import { Stack } from "@mui/material";
import React from "react";
import { DetailsBasePage } from "./DetailsBasePage.tsx";
import { Entry, ResumeListItem } from "./WorkDetails.tsx";
import spotifyDistanceImg from "./assets/projects/spotifyDistance.png";
import swiprImg from "./assets/projects/swipr.png";
import tempolImg from "./assets/projects/tempol.png";
import websiteV1Img from "./assets/projects/websiteV1.png";
import processorReviewImg from "./assets/projects/professor.png";
import { GitHub } from "@mui/icons-material";

const projects: Entry[] = [
  // {
  //   title: "Any Daylist - AI-Powered Playlist Curation",
  //   subtitle: "2024",
  //   link: "https://www.anydaylist.com",
  //   description:
  //     "Any Daylist is a music streaming service that uses AI to generate playlists based on user preferences. The service is built with React, TypeScript, and Node.js.",
  //   image: spotifyDistanceImg,
  //   skills: ["React", "TypeScript", "Node.js"],
  // },
  {
    title: "Spotify Distance - Degrees of Separation Algorithm",
    subtitle: "2021",
    description:
      "Interactive web application that calculates the degrees of separation between two Spotify Artists. Implemented with bidirectional search graph traversal algorithm. Single-page Vue.js interface consuming Spotify Web API to visualize artist connections dynamically.",
    image: spotifyDistanceImg,
    link: "https://tholt1220.github.io/Spotify-Distance/",
    skills: ["Vue.js", "Graph Search", "Spotify Web API", "GitHub Pages"],
  },
  {
    title: "Tempol - Musician Practice Aid",
    subtitle: "2020",
    description:
      "Audio transformation web application designed to help musicians practice to songs at a specified tempo using FFmpeg and beat detection algorithms. Created a RESTful API for playlist management and successfully deployed using Docker and AWS Elastic Beanstalk.",
    image: tempolImg,
    link: "https://github.com/tholt1220/Tempol",
    LinkIcon: GitHub,
    skills: ["Python", "Flask", "FFmpeg", "AWS Elastic Beanstalk", "Docker"],
  },
  {
    title: "Personal Website V1",
    subtitle: "2020",
    description:
      "V1 of personal website built with plain HTML/CSS and JavaScript. Hosted on GitHub Pages.",
    image: websiteV1Img,
    link: "https://tholt1220.github.io/portfolio-1.0/",
    skills: ["HTML", "CSS", "Javascript", "jQuery", "GitHub Pages"],
  },
  {
    title: "Swipr - Dining Hall Marketplace Mobile App",
    subtitle: "2019",
    description:
      "Android application for UCLA students to buy and sell dining hall meal swipes in a secure marketplace, addressing campus food accessibility and reducing meal plan waste. Implemented user authentication, and in-app communication features to facilitate safe and convenient peer-to-peer transactions.",
    image: swiprImg,
    LinkIcon: GitHub,
    link: "https://github.com/lucamatsumoto/swipr",
    skills: ["Java", "Android Studio", "Firebase"],
  },
  {
    title: "Professor Review",
    subtitle: "2018",
    description:
      "Comprehensive web scraping tool that aggregates and analyzes professor ratings across multiple platforms to provide UCLA students with data-driven insights into course experiences.",
    image: processorReviewImg,
    LinkIcon: GitHub,
    link: "https://github.com/tholt1220/ProfessorReview",
    skills: ["Python", "BeautifulSoup", "Pandas"],
  },
];

export const ProjectDetails = () => {
  return (
    <DetailsBasePage title="Projects">
      <Stack spacing={2}>
        {projects.map((entry, idx) => (
          <ResumeListItem entry={entry} key={entry.title} idx={idx} />
        ))}
      </Stack>
    </DetailsBasePage>
  );
};
